import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          size === 'large' ? 'aspect-[2/3]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 天狼影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <div className="flex items-center gap-1.5 mb-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-50 font-medium">{movie.rating}</span>
            </div>
            <p className="text-xs text-foreground-200 line-clamp-2">{movie.description}</p>
          </div>
        </div>

        <div className="absolute top-2 left-2">
          {movie.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
              新
            </span>
          )}
          {movie.isHot && !movie.isNew && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
              热播
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-background-950/70 text-foreground-200 text-[10px] rounded whitespace-nowrap">
            {movie.updateInfo}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-400 transition-colors duration-200">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-600 mt-1">{movie.actors.slice(0, 3).join(' / ')}</p>
    </Link>
  );
}